import styled from 'styled-components/macro'
import { darken } from 'polished'

import { shimmer } from 'utils/animations'

export const SkeletonElementStyle = styled.span<{ width: string; height: string; borderRadius: string }>`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  display: inline-flex;
  border-radius: ${(props) => props.borderRadius};
  user-select: none;
  animation: ${shimmer} 1.5s infinite;
  animation-fill-mode: both;
  background-image: linear-gradient(to left, #7c85a24d 25%, ${darken(0.8, '#7C85A24D')} 50%, #7c85a24d 75%);
  background-size: 400%;
  will-change: background-position;
`
